export default __webpack_public_path__ + "static/media/black-orange.62f427fb.png";